import React from 'react';
import PropTypes from 'prop-types';

import HeaderTitle from './HeaderTitle';
import ActionsSection from './ActionsSection';

const Header = ({selectedRowIds, globalFilter, setGlobalFilter, handleShow, handleOpen, handleLoad}) => {
	return (
		<div className="d-lg-flex justify-content-between">
			<HeaderTitle globalFilter={globalFilter} setGlobalFilter={setGlobalFilter} />
			<div className="border-bottom border-200 my-3"></div>
			<ActionsSection 
                selectedRowIds={selectedRowIds} 
                handleShow={handleShow} 
                handleOpen={handleOpen} 
                handleLoad={handleLoad}
            />
		</div>
	);
};

Header.propTypes = {
    selectedRowIds: PropTypes.object,
    globalFilter: PropTypes.string,
    setGlobalFilter: PropTypes.func,
    handleShow: PropTypes.func,
    handleOpen: PropTypes.func,
    handleLoad: PropTypes.func  // <--- Agregar esta línea para validar la prop `handleImport`
};

export default Header;
